import { render, staticRenderFns } from "./SetupPanel.vue?vue&type=template&id=6c9a9dd2&scoped=true"
import script from "./SetupPanel.vue?vue&type=script&lang=js"
export * from "./SetupPanel.vue?vue&type=script&lang=js"
import style0 from "./SetupPanel.vue?vue&type=style&index=0&id=6c9a9dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a9dd2",
  null
  
)

export default component.exports